"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "12",
  height: "14",
  viewBox: "0 0 12 14"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M6 14c-3.3 0-6-2.71-6-6.03 0-.25.2-.45.45-.45s.45.2.45.45C.9 10.8 3.2 13.1 6 13.1A5.12 5.12 0 006 2.85a.45.45 0 010-.9A6.03 6.03 0 016 14z"
}), /*#__PURE__*/_react["default"].createElement("path", {
  d: "M6.9 4.88a.44.44 0 01-.32-.14L4.61 2.75a.44.44 0 010-.63L6.58.14a.43.43 0 01.63 0c.18.18.18.45 0 .63L5.55 2.44 7.21 4.1c.18.18.18.45 0 .63-.06.1-.18.14-.31.14z"
}));

exports["default"] = _default;